<div class="create-core-firmware-version__header-container">
  <dcc-page-title class="create-core-firmware-version__header-container__header"
                  title="Add Version"></dcc-page-title>
  <div type="button"
       class="create-core-firmware-version__header-container__close"
       (click)="close()">
    <i class="lx-icon lx-close-x"></i>
  </div>
</div>

<div class="create-core-firmware-version__input-container">
  <div class="create-core-firmware-version__input">
    <div class="lx-label">Name
      <span class="lx-validation-warning"> *</span>
    </div>
    <div class="create-core-firmware-version__input-container__name"><textarea [(ngModel)]="firmwareName"
                name="firmwareName"
                id="firmwareName"
                placeholder="Enter Firmware Version Name"></textarea>
    </div>
  </div>

  <div class="create-core-firmware-version__input">
    <div class="lx-label">Select Platform Type
      <span class="lx-validation-warning"> *</span>
    </div>
    <div class="create-core-firmware-version__input-container__type">
      <ng-select id="platformType"
                 [(ngModel)]="platformType"
                 placeholder="Select Platform Type">
        <ng-option *ngFor="let platform of platformTypes"
                   [value]="platform">{{ platform }}</ng-option>
      </ng-select>
    </div>
  </div>

  <div class="create-core-firmware-version__input">
    <label for="firmwareFile"
           class="lx-label">Version File
      <span class="lx-validation-warning"> *</span></label>
    <input type="file"
           #versionFile
           style="display:none"
           autocomplete="off"
           (change)="onSelectVersionFile($event)"
           accept=".zip"
           name="firmwareFile"
           id="firmwareFile">
    <button class="create-core-firmware-version__input-container__file-icon x-btn lx-btn-small lx-btn-primary"
            (click)="versionFile.click()">Choose File</button>
    <p *ngIf="fileName">Selected file: {{ fileName }}</p>
  </div>
</div>

<div class="create-core-firmware-version__footer">
  <div class="create-core-firmware-version__footer__button-container">
    <button class="create-core-firmware-version__footer__button-container__close lx-btn lx-btn-secondary"
            (click)="close()">Cancel</button>
    <button class="create-core-firmware-version__footer__button-container__create lx-btn lx-btn-primary"
            (click)=create()
            [disabled]="isLoading">
      Add
    </button>
  </div>

  <dcc-module-spinner [isLoading]=isLoading></dcc-module-spinner>

</div>
